import React from 'react'

const Footer = () => {
  return (
    <div className='Footer'>© TTP Hackathon 2024 Submission</div>
  )
}

export default Footer